import IconButton from "@mui/material/IconButton";

import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { Grid, Stack } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import DateRangePicker from "components/DateRangePicker";
import moment from "moment";

const DatePeriodSelector = ({ value, onChange }) => {
  const goToPrevWeek = () => {
    onChange(moment(value[0]).add(-1, "week"));
  };

  const goToNextWeek = () => {
    onChange(moment(value[0]).add(1, "week"));
  };

  const goToCurrentWeek = () => {
    onChange(moment());
  };

  return (
    <Stack
      sx={{ width: "450px", position: "relative", display: "flex", alignItems: "center" }}
      direction="row"
      spacing={0.5}
    >
      <IconButton color="dark" onClick={goToPrevWeek}>
        <KeyboardArrowLeft />
      </IconButton>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <DateRangePicker
          value={value}
          onChange={onChange}
          error=""
          onGoToCurrent={goToCurrentWeek}
        />
      </LocalizationProvider>
      <IconButton color="dark" onClick={goToNextWeek}>
        <KeyboardArrowRight />
      </IconButton>
    </Stack>
  );
};

// Setting default values for the props
DatePeriodSelector.defaultProps = {};

// Typechecking props
DatePeriodSelector.propTypes = {};

export default DatePeriodSelector;
